import { useContext } from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import { clientUrls } from "misc/urls/clientUrls";
import { CheckAppPermissions } from "misc/authentication";
import { UserManagementRoles } from "misc/roles";

import { Card } from "misc/card";
import { Result } from "misc/results";
import UsersListComponent from "admin/components/UsersListComponent";
import UserComponent from "admin/components/UserComponent";
import { LoggedInUserContext } from "context/LoggedInUserContext";
import { useUsers } from "misc/api/keycloakApi";

const UserContainer = () => {
    const { activeOrganization } = useContext(LoggedInUserContext);

    // Prefetching
    useUsers({ suspense: true });

    return (
        <CheckAppPermissions
            allowed={[UserManagementRoles.PermissionAuthorityFull, UserManagementRoles.PermissionAuthorityLocalAdmin]}
            config={{ orgId: activeOrganization?.id }}
            fallback={
                <Card>
                    <Result type="unauthorizedAccess" />
                </Card>
            }
        >
            <Switch>
                <Route exact path={clientUrls.users.baseUrl()} component={UsersListComponent} />
                <Route exact path={clientUrls.users.create()} component={UserComponent} />
                <Route exact path={clientUrls.users.edit()} component={UserComponent} />
                <Redirect to={clientUrls.users.baseUrl()} />
            </Switch>
        </CheckAppPermissions>
    );
};

export default UserContainer;
